<ng-container [formGroup]="formGroup">
  <div class="code-field">
    <app-otp-field
      [size]="size"
      [formControlName]="fieldName"
      [class]="validation()"
      (completed)="complete()"
    ></app-otp-field>

    <div class="code-field-loader">
      <p-progressBar
        *ngIf="loading"
        mode="indeterminate"
      ></p-progressBar>
    </div>
  </div>
  <app-error-message
    [control]="control"
    [field]="fieldName"
  ></app-error-message>
</ng-container>
